import { MapPin } from 'lucide-react';

interface EmbeddedMapProps {
  lat: number;
  lng: number;
  formattedAddress?: string;
  zoom?: number;
  height?: number;
  className?: string;
}

export function EmbeddedMap({
  lat,
  lng,
  formattedAddress,
  zoom = 15,
  height = 300,
  className = '',
}: EmbeddedMapProps) {
  return (
    <section className={`space-y-3 ${className}`}>
      {formattedAddress && (
        <div className="flex items-center gap-2 text-sm text-gray-700">
          <MapPin className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span>{formattedAddress}</span>
        </div>
      )}
      <div className="rounded-xl overflow-hidden border border-gray-200">
        <iframe
          title="Location map"
          width="100%"
          height={height}
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://maps.google.com/maps?q=${formattedAddress ? encodeURIComponent(formattedAddress) : `${lat},${lng}`}&z=${zoom}&output=embed`}
        />
      </div>
    </section>
  );
}
